import { render, staticRenderFns } from "./OtherData.vue?vue&type=template&id=e293c6d4"
import script from "./OtherData.vue?vue&type=script&lang=js"
export * from "./OtherData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports